import {
  getToPayInfo,
  webUnifiedOrder,
  appletPayBillno,
} from '@/api/request'

const user = {
  state: {},

  mutations: {},
  actions: {

    GetToPayInfo({
      commit,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        getToPayInfo(params)
          .then((response) => {
            if (response.data.Code == 1) {
              console.log("获取配置信息", response.data.Data)
              resolve(response.data.Data);
            } else {
              alert(response.data.Msg)
            }
          })
          .catch(() => {
            console.log("error", response);
          })
      })
    },
    WebUnifiedOrder({
      commit,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        webUnifiedOrder(params)
          .then((response) => {
            if (response.data.code == 0) {
              console.log("下单参数", response.data.data)
              resolve(response.data.data);
            } else if (response.data.Code == 1) {
              console.log("下单参数", response.data.Data)
              resolve(response.data.Data);
            } else {
              alert("下单错误" + (response.data.msg || response.data.Msg))
            }

          })
          .catch(() => {
            console.log("error", response);
          })
      })
    },
    
    AppletPayBillno({
      commit,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        appletPayBillno(params)
          .then((response) => {
            if (response.data.Code == 1) {
              console.log("获取订单号", response.data.Data)
              resolve(response.data.Data);
            } else {
              alert(response.data.Msg)
            }
          })
          .catch(() => {
            console.log("error", response);
          })
      })
    },

  }
}

export default {
  user: user,

}



// WEBPACK FOOTER //
// ./src/store/modules/index.js